import React, { useEffect, useState } from "react";
import { AiOutlineDownload, AiOutlinePlus } from "react-icons/ai";
import { SiMicrosoftexcel } from "react-icons/si";
import { RiSearch2Line } from "react-icons/ri";

import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from "@mui/material";

import {
    Box,
    Button,
    Checkbox,
    Chip,
    Grid,
    Icon,
    InputAdornment,
    ListItem,
    Menu,
    MenuItem,
    TextField,
} from "@mui/material";

import { BsArrowRightCircle } from "react-icons/bs";
import { RiDeleteBinLine } from "react-icons/ri";

import { makeStyles } from "@material-ui/core";

// import LeadCreatForm from "./createLeads/LeadCreatForm";
import { useDispatch, useSelector } from "react-redux";
import { leadFindAction } from "../../actions/leadActions/leadActions";
import { findBranchMasterAction } from "../../actions/branchMasterActions";
import {
    b2bManagerStaffFindAction,
    branchManagerFetchAction,
    teamLeadStaffsFindAction,
} from "../../actions/employeeManagmentAction";
import { OutLinedButton, SubmitButton } from "../customComponent/Buttons";
import Swal from "sweetalert2";
import { SelectAssignUserForLeadPartner, SelectInputField } from "../customComponent/InputField";
import PartnerCreateForm from "./PartnerCreateForm";
import {
    partnerManagerChangeAction,
    teamLeadAssignStaffChangeAction,
} from "../../actions/partnerAction/partnerAction";
import { successTrueMsgAction } from "../../actions/globalAction";

const useStyles = makeStyles((theme) => ({
    searchContainer: {
        display: "flex",
        alignItems: "center",
        marginBottom: theme.spacing(2),
        padding: theme.spacing(1),
    },
    searchInput: {
        marginLeft: theme.spacing(1),
    },
}));

function PartnerLeadSearch({
    columnVisibleHandler,
    excelDownloadClick,
    pdfDownloadClick,
    searchHandleChange,
    component,
    filterPassData,
    whichFilter,
    handleResetData,
    handleDeleteClick,
    ids,
    leadId,
    noAction,
    column,
    viewedColumn,
    declarationComponent,
    handleSearchChange,
    selectedIds,
}) {
    const classes = useStyles();
    const dispatch = useDispatch();

    const [anchorEl, setAnchorEl] = useState(null);
    const [searchText, setSearchText] = useState("");
    const [addForm, setAddForm] = React.useState(false);
    const [chipData, setChipData] = useState([]);
    const [openOwner, setOpenOwner] = useState(false);
    const [dialogModel, setDialogModel] = useState("");
    const [branchManager, setBranchManager] = useState();

    let { branchManagerLoading, branchManagerSuccess, branchManagerError } =
        useSelector((state) => {
            return state.branchManagerFetch;
        });

    let { b2bManagerSuccess } = useSelector((s) => s.b2bManagerFetch);

    useEffect(() => {
        dispatch(leadFindAction());
    }, [dispatch]);

    useEffect(() => {
        dispatch(findBranchMasterAction());
    }, [dispatch, dialogModel]);

    useEffect(() => {
        if (dialogModel === "Leader") {
            dispatch(branchManagerFetchAction("", dialogModel));
        }
    }, [dispatch, dialogModel]);

    useEffect(() => {
        if (dialogModel === "assignUser") {
            // dispatch(teamLeadStaffsFindAction());
            dispatch(b2bManagerStaffFindAction(selectedIds));
        }
    }, [dispatch, dialogModel]);

    useEffect(() => {
        if (whichFilter !== null && filterPassData !== null) {
            setChipData((prevChipData) => {
                const updatedChipData = prevChipData.map((chip) => {
                    if (chip.label === whichFilter) {
                        return {
                            ...chip,
                            result: filterPassData,
                        };
                    }
                    return chip;
                });

                if (!updatedChipData.some((chip) => chip.label === whichFilter)) {
                    return [
                        ...updatedChipData,
                        { label: whichFilter, result: filterPassData },
                    ];
                }

                return updatedChipData;
            });
        } else {
            setChipData([]);
        }
    }, [whichFilter, filterPassData]);

    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleStateChange = () => {
        setAddForm(false);
    };
    // button Export
    const [exportShow, setExportShow] = React.useState(null);
    const openExport = Boolean(exportShow);

    const handleClickExport = (event) => {
        setExportShow(event.currentTarget);
    };
    const handleCloseExport = () => {
        setExportShow(null);
    };

    const handleClickOpen = (dialogModelName) => {
        setDialogModel(dialogModelName);
        setOpenOwner(true);
    };

    const handleOwnerChange = (event) => {
        setBranchManager(event.target.value);
    };

    const handlePopClose = () => {
        setOpenOwner(false);
    };
    // button Action
    const [actionShow, setActionShow] = React.useState(null);
    const openAction = Boolean(actionShow);

    const handleClickAction = (event) => {
        setActionShow(event.currentTarget);
    };
    const handleCloseAction = () => {
        setActionShow(null);
    };

    // chip
    const handleDelete = (chipToDelete) => () => {
        setChipData((chips) => chips.filter((chip) => chip.label !== chipToDelete));
        handleResetData(true);
    };

    const handleMethodApplyClick = () => {
        if (ids.length !== 0 || leadId.length !== 0) {
            if (component == "application") {
                dispatch(
                    teamLeadAssignStaffChangeAction(
                        ids.length !== 0 ? ids : leadId,
                        branchManager?.id,
                    ),
                );
            } else {
                setOpenOwner(false);
                dispatch(
                    partnerManagerChangeAction(
                        ids.length !== 0 ? ids : leadId,
                        branchManager?.id,
                    ),
                );
            }
            dispatch(successTrueMsgAction(true));
        } else {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `Please choose any one`,
            });
        }
    };

    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={3}>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "start",
                            marginTop: "5px",
                            width: "auto",
                            fontSize: "8px",
                        }}
                    >
                        {chipData.map((data, index) => {
                            return (
                                <ListItem key={index} style={{ marginBottom: "2px" }}>
                                    <Chip
                                        size="small"
                                        className="MuiChip-sizeSmall"
                                        classes={{
                                            iconSmall: "MuiChip-iconSmall",
                                            labelSmall: "MuiChip-labelSmall",
                                        }}
                                        icon={`${data.label}:`}
                                        onDelete={handleDelete(data.label)}
                                        label={
                                            <Typography variant="body2" style={{ fontSize: 12 }}>
                                                <span style={{ fontWeight: 600, fontSize: 12 }}>
                                                    {whichFilter}:{" "}
                                                </span>
                                                {data.result}
                                            </Typography>
                                        }
                                        style={{
                                            fontWeight: 90,
                                            fontSize: 10,
                                            marginLeft: "-10px",
                                        }}
                                    />
                                </ListItem>
                            );
                        })}
                    </div>
                </Grid>
                <Grid item xs={9}>
                    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                        <Grid>
                            <form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    const syntheticEvent = {
                                        target: {
                                            value: searchText,
                                        },
                                    };
                                    searchHandleChange(syntheticEvent);
                                }}
                            >
                                <div className={classes.searchContainer}>
                                    <TextField
                                        className={classes.searchInput}
                                        variant="outlined"
                                        placeholder="Search Here"
                                        value={searchText}
                                        onChange={(e) => {
                                            setSearchText(e.target.value);
                                            // searchHandleChange(e);
                                            handleSearchChange(e);
                                        }}
                                        sx={{
                                            "& .MuiInputBase-input": {
                                                borderRadius: "20px",
                                                height: "1px",
                                                paddingRight: "48px !important",
                                            },
                                            "& .MuiFormLabel-root": {
                                                lineHeight: "5px",
                                            },

                                            "& .MuiInputBase-root": {
                                                borderRadius: "3px",
                                                borderColor: "#fafafa",
                                            },
                                            "& .MuiOutlinedInput-notchedOutline ": {
                                                borderRadius: "3px",
                                                borderColor: "#ECECEC !important",
                                                borderWidth: "1px !important",
                                            },
                                        }}
                                    />
                                    <>
                                        <InputAdornment
                                            position="end"
                                            sx={{
                                                right: "8px",
                                                width: "40px",
                                                border: "1px solid #ECECEC",
                                                borderRadius: "3px",
                                                height: "34px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                cursor: "pointer",
                                            }}
                                        >
                                            <button
                                                type="submit"
                                                style={{
                                                    background: "none",
                                                    border: "none",
                                                    cursor: "pointer",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    width: "100%",
                                                    height: "100%",
                                                }}
                                            >
                                                <RiSearch2Line />
                                            </button>
                                        </InputAdornment>
                                    </>
                                </div>
                            </form>
                        </Grid>
                        <Grid sx={{ margin: 1 }}>
                            <OutLinedButton
                                id="demo-positioned-button"
                                aria-controls={open ? "demo-positioned-menu" : undefined}
                                aria-haspopup="true"
                                aria-expanded={open ? "true" : undefined}
                                title="Column visibility"
                                handleClick={handleClick}
                                widthSize="182px"
                                heightSize="30px"
                            />
                            <Menu
                                id="demo-positioned-menu"
                                aria-labelledby="demo-positioned-button"
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                                anchorOrigin={{
                                    vertical: "top",
                                    horizontal: "left",
                                }}
                                transformOrigin={{
                                    vertical: "top",
                                    horizontal: "left",
                                }}
                                sx={{
                                    borderColor: "black",
                                    borderRadius: "24px",
                                    mt: 6,
                                    "& ul": {
                                        maxHeight: "250px",
                                        overflow: "scroll",
                                    },
                                    "& ul::-webkit-scrollbar": {
                                        display: "none",
                                    },
                                }}
                            >
                                {column?.map((value, indx) => (
                                    <MenuItem key={indx}>
                                        <Checkbox
                                            sx={{
                                                color: "#F8469A",
                                                "&.Mui-checked": {
                                                    color: "#F8469A",
                                                },
                                            }}
                                            checked={
                                                viewedColumn?.includes(value?.field) ? true : false
                                            }
                                            onChange={(e) =>
                                                columnVisibleHandler(e.target.checked, value?.field)
                                            }
                                        />
                                        {value.title}
                                    </MenuItem>
                                ))}
                            </Menu>
                        </Grid>

                        {declarationComponent !== "declarationApproval" && (
                            <Grid sx={{ margin: 1 }}>
                                <OutLinedButton
                                    title="Export"
                                    handleClick={handleClickExport}
                                    widthSize="auto"
                                    heightSize="30px"
                                />

                                <Menu
                                    id="demo-positioned-menu"
                                    aria-labelledby="demo-positioned-button"
                                    anchorEl={exportShow}
                                    open={openExport}
                                    onClose={handleCloseExport}
                                    anchorOrigin={{
                                        vertical: "top",
                                        horizontal: "left",
                                    }}
                                    transformOrigin={{
                                        vertical: "top",
                                        horizontal: "left",
                                    }}
                                    sx={{ borderColor: "black", borderRadius: "24px", mt: 6 }}
                                >
                                    <MenuItem onClick={pdfDownloadClick}>
                                        <Icon fontSize="medium" color="secondary" sx={{ m: 1 }}>
                                            <AiOutlineDownload
                                                style={{ color: "#141E3C", fontSize: "24px" }}
                                            />
                                        </Icon>
                                        Pdf
                                    </MenuItem>
                                    <MenuItem onClick={excelDownloadClick}>
                                        <Icon fontSize="medium" color="secondary" sx={{ m: 1 }}>
                                            <SiMicrosoftexcel
                                                style={{ color: "#141E3C", fontSize: "24px" }}
                                            />
                                        </Icon>
                                        Excel
                                    </MenuItem>
                                </Menu>
                            </Grid>
                        )}

                        {/* Action Button */}
                        {!noAction && declarationComponent !== "declarationApproval" && (
                            <Grid sx={{ margin: 1 }}>
                                <SubmitButton
                                    title="Action"
                                    submit=""
                                    widthSize="75px"
                                    heightSize="30px"
                                    type="click"
                                    handleSubmit={handleClickAction}
                                />

                                <Menu
                                    id="demo-positioned-menu"
                                    aria-labelledby="demo-positioned-button"
                                    anchorEl={actionShow}
                                    open={openAction}
                                    onClose={handleCloseAction}
                                    anchorOrigin={{
                                        vertical: "top",
                                        horizontal: "left",
                                    }}
                                    transformOrigin={{
                                        vertical: "top",
                                        horizontal: "left",
                                    }}
                                    sx={{
                                        borderColor: "rgba(20, 30, 60, 1)",
                                        borderRadius: "24px",
                                        mt: 6,
                                        width: "280px",
                                        height: "503px",
                                    }}
                                >
                                    {/* Example: Uncomment and use privilege checks as needed */}
                                    {/* {isCreateNewPartnerPrevilage(subMenu) && ( */}
                                    <MenuItem>
                                        <Button
                                            startIcon={<AiOutlinePlus />}
                                            sx={{
                                                backgroundColor: "#141E3C",
                                                color: "white",
                                                "&:hover": {
                                                    backgroundColor: "rgba(20, 30, 60, 0.9)",
                                                },
                                            }}
                                            onClick={() => setAddForm(true)}
                                        >
                                            Create a New Partner
                                        </Button>
                                    </MenuItem>
                                    <MenuItem>
                                        <Button
                                            startIcon={<BsArrowRightCircle />}
                                            onClick={() =>
                                                handleClickOpen(
                                                    component === "application" ? "assignUser" : "Leader",
                                                )
                                            }
                                        >
                                            {component === "application"
                                                ? "Assign User"
                                                : "Change Leader"}
                                        </Button>
                                    </MenuItem>
                                    <MenuItem>
                                        <Button
                                            startIcon={<RiDeleteBinLine />}
                                            onClick={handleDeleteClick}
                                        >
                                            Delete
                                        </Button>
                                    </MenuItem>
                                </Menu>
                                {addForm && (
                                    <PartnerCreateForm
                                        addForm={addForm}
                                        handleStateChange={handleStateChange}
                                    />
                                )}
                            </Grid>
                        )}
                    </Box>
                </Grid>
            </Grid>

            <Dialog
                open={openOwner}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    sx: {
                        bottom: dialogModel === "Leader" ? "25vh" : "30vh",
                        width: "850px",
                    },
                }}
            >
                <DialogTitle
                    id="alert-dialog-title"
                    sx={{ fontSize: "22px", fontWeight: 700 }}
                >
                    {dialogModel === "Leader"
                        ? "Change Leader"
                        : dialogModel === "assignUser"
                            ? "Assign User"
                            : null}
                </DialogTitle>
                {dialogModel === "Leader" ? (
                    <>
                        <DialogContent>
                            <Box sx={{ mt: 2 }}>
                                <SelectInputField
                                    label="Choose Team Lead"
                                    handleSelectChange={handleOwnerChange}
                                    widthSize="160px"
                                    value={branchManager}
                                    mapValue={branchManagerSuccess && branchManagerSuccess}
                                    mapMethod="branchManager"
                                />
                            </Box>
                            <Box sx={{ mt: 2.5 }}></Box>
                        </DialogContent>
                        <DialogActions>
                            <OutLinedButton
                                title="Cancel"
                                handleClick={handlePopClose}
                                widthSize="75px"
                                heightSize="30px"
                            />

                            <SubmitButton
                                title="Submit"
                                submit=""
                                widthSize="75px"
                                heightSize="30px"
                                type="click"
                                handleSubmit={handleMethodApplyClick}
                            />
                        </DialogActions>{" "}
                    </>
                ) : dialogModel === "assignUser" ? (
                    <>
                        <DialogContent>
                            <Box sx={{ mt: 2 }}>
                                <SelectAssignUserForLeadPartner
                                    label="Assign Staff"
                                    handleSelectChange={handleOwnerChange}
                                    widthSize="160px"
                                    value={branchManager}
                                    mapValue={b2bManagerSuccess?.allStaffs}
                                    mapMethod="branchManager"
                                />
                            </Box>
                        </DialogContent>
                        <DialogActions>
                            <OutLinedButton
                                title="Cancel"
                                handleClick={handlePopClose}
                                widthSize="75px"
                                heightSize="30px"
                            />

                            <SubmitButton
                                title="Submit"
                                submit=""
                                widthSize="75px"
                                heightSize="30px"
                                type="click"
                                handleSubmit={handleMethodApplyClick}
                            />
                        </DialogActions>{" "}
                    </>
                ) : null}
            </Dialog>
        </>
    );
}

export default PartnerLeadSearch;